<template>
  <div class="purchase-detail-page">
    <div class="purchase-detail-container">
      <!-- 采购详情 -->
      <div class="form-section" style="display: flex; justify-content: space-between; align-items: center;">
        <v-table class="purchase-detail-table" hover style="width: 88%">
          <thead>
            <tr>
              <th v-for="header in purchaseDetailHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.width }">
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading" style="height: 60px;">
              <td :colspan="purchaseDetailHeaders.length" class="text-center">加载中...</td>
            </tr>
            <tr v-else-if="!purchaseDetail" style="height: 60px;">
              <td :colspan="purchaseDetailHeaders.length" class="text-center">暂无数据</td>
            </tr>
            <tr v-else style="height: 90px;">
              <td class="text-start">
                {{ purchaseDetail.purchaseOrderNo || '-' }}
                <div style="color: #898989">{{ formatNYDate(purchaseDetail.createTime) }}</div>
              </td>
              <td class="text-start">
                <div>{{ purchaseDetail.supplierName || '/' }}</div>
                <div style="color: #898989">{{ purchaseDetail.supplierNo || '/' }}</div>
              </td>
              <!-- <td class="text-start">
                {{ purchaseDetail.goodsName || '/' }} <br>
                <div style="color: #898989" v-if="purchaseDetail.goodsSpec">{{ purchaseDetail.goodsSpec }}</div>
                <div style="color: #898989" v-if="purchaseDetail.goodsNo">{{ purchaseDetail.goodsNo }}</div>
              </td> -->
              <!-- <td class="text-center">{{ purchaseDetail.materialRemark || '/' }}</td>
              <td class="text-center">{{ purchaseDetail.quantity || '/' }}</td>
              <td class="text-center">{{ purchaseDetail.goodsUnit || '/' }}</td>
              <td class="text-center">{{ purchaseDetail.price || '/' }}</td> -->
              <td class="text-center">{{ formatNumber(Number(purchaseDetail.totalPrice)) }}</td>
              <td class="text-center">
                <div class="payment-type">{{ getPaymentMethod(purchaseDetail.paymentType).label || '/' }}</div>
              </td>
              <td class="text-center">
                {{ formatNYDate(purchaseDetail.schDate) }}
              </td>
              <!-- <td class="text-center" data-key="inboundStatus">
                <div v-if="purchaseDetail.qualityStatus === Number(0)">
                  <img src="@/assets/qualityOff.png" alt="未确认" style="width: 50px;">
                </div>
                <div v-else-if="purchaseDetail.qualityStatus === Number(1)">
                  <img src="@/assets/qualityOn.png" alt="已确认" style="width: 50px;">
                </div>
                <div v-if="purchaseDetail.warehouseStatus === Number(0)">
                  <img src="@/assets/storageOff.png" alt="未确认" style="width: 50px;">
                </div>
                <div v-else-if="purchaseDetail.warehouseStatus === Number(1)">
                  <img src="@/assets/storageOn.png" alt="已确认" style="width: 50px;">
                </div>
              </td> -->
              <td class="text-center">{{ purchaseDetail?.user?.nickname || '/' }}</td>
              <td class="text-center">{{ purchaseDetail?.warehouseName || '/' }}</td>
            </tr>
          </tbody>
        </v-table>
        <!-- 采购单二维码 -->
        <div class="qrcode-container" v-if="purchaseDetail?.id">
          <img :src="getQRCodeUrl(purchaseDetail?.id)" alt="采购单二维码" style="height: 146px;">
        </div>
      </div>
      <!-- 明细 -->
      <div class="form-section">
        <div class="section-title" style="margin-bottom: 16px;margin-top: 30px;">明细</div>
        <v-table class="purchase-detail-table" hover>
          <thead>
            <tr>
              <th v-for="header in detailHead" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.width }">
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td :colspan="detailHead.length" class="text-center">加载中...</td>
            </tr>
            <tr v-else-if="purchaseDetailList.length === 0">
              <td :colspan="detailHead.length" class="text-center">暂无付款记录</td>
            </tr>
            <tr v-else v-for="record in purchaseDetailList" :key="record.id" style="height: 80px;">
              <td class="text-start">
                {{ record.goodsName }} <br>
                <div style="color: #898989" v-if="record.goodsSpec">{{ record.goodsSpec }}</div>
                <div style="color: #898989" v-if="record.goodsNo">{{ record.goodsNo }}</div>
              </td>
              <td class="text-center">{{ record.brand || '/' }}</td>
              <td class="text-center">{{ record.quantity || '/' }}</td>
              <td class="text-center">{{ record.unit || '/' }}</td>
              <td class="text-center">{{ record.price || '/' }}</td>
              <td class="text-center">{{ formatNumber(Number(record.totalPrice)) || '/' }}</td>
              <td class="text-center">{{ record.remark || '/' }}</td>
              <td class="text-center" data-key="inboundStatus">
                <div v-if="record.qualityStatus === Number(0)">
                  <img src="@/assets/qualityOff.png" alt="未确认" style="width: 50px;">
                </div>
                <div v-else-if="record.qualityStatus === Number(1)">
                  <img src="@/assets/qualityOn.png" alt="已确认" style="width: 50px;">
                </div>
                <div v-if="record.warehouseStatus === Number(0)">
                  <img src="@/assets/storageOff.png" alt="未确认" style="width: 50px;">
                </div>
                <div v-else-if="record.warehouseStatus === Number(1)">
                  <img src="@/assets/storageOn.png" alt="已确认" style="width: 50px;">
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
      <!-- 付款记录 -->
      <div class="form-section">
        <div style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 16px;margin-top: 30px;">
          <div style="display: flex; justify-content: start; align-items: center;">
            <div class="section-title">付款记录</div>
            <div style="color: #E8E8E8;font-size: 14px;margin-left: 18px;">已付：{{ formatNumber(Number(purchaseDetail?.paidAmount)) }}</div>
            <div style="color: #E8E8E8;font-size: 14px;margin-left: 18px;">已付比例：{{ purchaseDetail?.paidRatio && purchaseDetail?.paidRatio !== 0 ? purchaseDetail?.paidRatio + '%' : '/' }}</div>
          </div>
          <v-btn color="primary" variant="flat" @click="openPaymentDialog" v-if="userType === 'purchase'">付款申请</v-btn>
        </div>
        <v-table class="purchase-detail-table" hover>
          <thead>
            <tr>
              <th v-for="header in paymentRecordHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.width }">
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td :colspan="paymentRecordHeaders.length" class="text-center">加载中...</td>
            </tr>
            <tr v-else-if="paymentRecords.length === 0">
              <td :colspan="paymentRecordHeaders.length" class="text-center">暂无付款记录</td>
            </tr>
            <tr v-else v-for="record in paymentRecords" :key="record.id">
              <td class="text-center">{{ formatNYDate(record.createTime) }}</td>
              <td class="text-center">{{ formatNumber(Number(record.applyAmount)) }}</td>
              <td class="text-center">{{ record.applyPercentage ? record.applyPercentage + '%' : '/' }}</td>
              <td class="text-center">
                <template v-if="record.signatoryName && record.signatoryName.length > 0">
                  <div v-for="signatory in record.signatoryName" :key="signatory">
                    {{ signatory }}
                  </div>
                </template>
                <template v-else>
                  <div>/</div>
                </template>
              </td>
              <td class="text-center">
                <template v-if="record.receiptImages && record.receiptImages.length > 0">
                  <div class="image-preview-item">
                    <v-img
                      :src="getImagePreviewUrl(record.receiptImages[0])"
                      contain
                      class="preview-image"
                    ></v-img>
                    <div class="image-actions"  @click="handleImagePreview(record.receiptImages, index, 0, false, 'voucher')">
                      <v-icon 
                        icon="mdi-eye" 
                        size="20"
                        @click.stop="handleImagePreview(record.receiptImages, index, 0, false, 'voucher')"
                      ></v-icon>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="image-preview-item">
                    <img style="width: 100%;height: 100%;" src="@/assets/noImg.jpg" alt="回单">
                  </div>
                </template>
                <!-- <div v-for="receiptImage in record.receiptImages" :key="receiptImage"> -->
                  <!-- <img :src="receiptImage" alt="回单" style="width: 50px;"> -->
                <!-- </div> -->
              </td>
              <td class="text-center">
                <v-btn variant="flat" color="primary" @click="signPayment(record)" v-if="userType === 'sign'">签字</v-btn>
                <v-btn variant="flat" color="primary" @click="uploadInvoice(record)" v-if="userType === 'payment' && Number(record.status) !== 2">上传回单</v-btn>
                <div class="status-text" v-if="userType === 'payment' && Number(record.status) === 2">已付款</div>
                <div class="status-text" v-if="userType === 'purchase' && Number(record.status) === 0">待签字</div>
                <div class="status-text" v-if="userType === 'purchase' && Number(record.status) === 1">已签字</div>
                <div class="status-text" v-if="userType === 'purchase' && Number(record.status) === 2">已付款</div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </div>
    <!-- 上传回单弹窗 -->
    <v-dialog v-model="showUploadInvoiceDialog" max-width="500">
      <FileAndImgUpload
        accept=".pdf,.jpg,.jpeg,.png"
        :multiple="true"
        icon="mdi-file-document"
        acceptText="支持图片、PDF格式"
        @upload="handleUploadInvoice"
      />
    </v-dialog>
    <!-- 付款申请弹窗 -->
    <v-dialog v-model="paymentDialog" max-width="600px" persistent>
      <v-card class="payment-dialog">
        <v-card-title class="dialog-title">
          <span class="text-h5">付款申请</span>
          <v-btn icon="mdi-close" variant="text" @click="closePaymentDialog"></v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="paymentFormRef">
            <v-row>
              <v-col cols="6">
                <!-- prefix="¥" -->
                <v-text-field
                  v-model="paymentForm.applyAmount"
                  label="金额"
                  persistent-placeholder
                  placeholder="请输入金额"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  @input="calculatePercentage"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <!-- suffix="%" -->
                <v-text-field
                  v-model="paymentForm.applyPercentage"
                  label="百分比"
                  persistent-placeholder
                  placeholder="请输入百分比"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  @input="calculateAmount"
                  suffix="%"
                ></v-text-field>
              </v-col>

              <!-- <v-col cols="12" class="py-0">
                <v-alert type="info" variant="tonal" density="compact">
                  <div style="font-size: 12px;">
                    <div>订单总金额: ¥{{ totalAmount }}</div>
                    <div>已付金额: ¥{{ purchaseDetail?.paidAmount || 0 }}</div>
                    <div>未付金额: ¥{{ unpaidAmount }}</div>
                  </div>
                </v-alert>
              </v-col> -->
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="error" variant="tonal" @click="closePaymentDialog">取消</v-btn>
          <v-btn color="primary" variant="flat" @click="submitPaymentApplication" :loading="submitting">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 签字确认弹窗 -->
    <v-dialog v-model="signConfirmDialog" max-width="500px" persistent>
      <v-card class="payment-dialog">
        <v-card-title class="dialog-title">
          <span class="text-h5">签字确认</span>
          <v-btn icon="mdi-close" variant="text" @click="cancelSign"></v-btn>
        </v-card-title>

        <v-card-text>
          <!-- <div style="padding: 24px 0; color: #fff; font-size: 16px;"> -->
            <!-- <div style="margin-bottom: 16px;">
              <span style="color: rgba(255, 255, 255, 0.7);">申请金额：</span>
              <span style="font-weight: 500;">¥{{ currentSignRecord?.applyAmount || 0 }}</span>
            </div>
            <div style="margin-bottom: 16px;" v-if="currentSignRecord?.applyPercentage">
              <span style="color: rgba(255, 255, 255, 0.7);">申请比例：</span>
              <span style="font-weight: 500;">{{ currentSignRecord?.applyPercentage }}%</span>
            </div> -->
            <!-- <div style="margin-top: 24px; padding: 16px; background-color: rgba(255, 255, 255, 0.05); border-radius: 4px;"> -->
              <span style="color: rgba(255, 255, 255, 0.7);">确认要对此付款申请进行签字吗？</span>
            <!-- </div> -->
          <!-- </div> -->
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="error" variant="tonal" @click="cancelSign">取消</v-btn>
          <v-btn color="primary" variant="flat" @click="confirmSign" :loading="loading">确认</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 图片预览弹窗 -->
    <ImagePreviewDialog
      v-model="showPreview"
      :image-list="previewImage"
      :current-material-index="currentParentIndex"
      :selected-index="selectedIndex"
      :is-delete="isDelete"
      :type="type"
      @close="handleClosePreview"
      @delete="handleDeleteImage"
    />

    <!-- 公共Loading组件 -->
    <div v-if="showCommonLoading" class="common-loading-overlay">
      <div class="common-loading-container">
        <div class="common-loading-spinner"></div>
        <p class="common-loading-text">{{ commonLoadingText || '加载中...' }}</p>
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import { ref, onUnmounted, onMounted, computed, nextTick, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { purchaseApi, type PurchaseOrder, type PaymentApplicationItem } from '@/services/api'
import { useSnackbar } from '@/composables/useSnackbar'
import { useUserStore } from '@/stores/user'
import FileAndImgUpload from '@/components/FileAndImgUpload.vue'
import ImagePreviewDialog from '@/components/ImagePreviewDialog.vue'

const userStore = useUserStore()
console.log('8888888888888888888888888',userStore.userInfo)

// jf_p_p_s
const router = useRouter()
const route = useRoute()
const { showSuccess, showError } = useSnackbar()

// 采购详情数据
const purchaseDetail = ref<PurchaseOrder | null>(null)
// 付款记录数据
const paymentRecords = ref<PaymentApplicationItem[]>([])
// 采购明细
const purchaseDetailList = ref<PurchaseOrder[]>([])
// 加载状态
const loading = ref(false)

// 付款申请弹窗状态
const paymentDialog = ref(false)
const submitting = ref(false)
const paymentFormRef = ref()

// 签字确认弹窗状态
const signConfirmDialog = ref(false)
const currentSignRecord = ref<PaymentApplicationItem | null>(null)

const userType = ref<string>('purchase')
// 付款申请表单数据
const paymentForm = ref({
  applyAmount: '',
  applyPercentage: ''
})

// 上传回单
const currentUploadInvoiceRecord = ref<PaymentApplicationItem | null>(null)
const showUploadInvoiceDialog = ref(false)
const showCommonLoading = ref(false)
const commonLoadingText = ref('')

// 表单验证规则
const rules = {
  required: (value: any) => !!value || '此项为必填项',
  positiveNumber: (value: any) => {
    if (!value) return true
    const num = parseFloat(value)
    return num > 0 || '金额必须大于0'
  },
  percentage: (value: any) => {
    if (!value) return true
    const num = parseFloat(value)
    return (num > 0 && num <= 100) || '百分比必须在0-100之间'
  }
}

// 计算订单总金额
const totalAmount = computed(() => {
  return purchaseDetail.value.totalPrice
  // if (!purchaseDetail.value) return 0
  // return (purchaseDetail.value.quantity * purchaseDetail.value.price).toFixed(2)
})

// 计算未付金额
const unpaidAmount = computed(() => {
  // return purchaseDetail.value.totalPrice - purchaseDetail.value.paidAmount

  // const total = parseFloat(totalAmount.value as string)
  // const paid = purchaseDetail.value?.paidAmount || 0
  // return (total - paid).toFixed(2)

  let totalAmount = 0
  paymentRecords.value.forEach((item: any) => {
    totalAmount += item.applyAmount
  })
  return purchaseDetail.value.totalPrice - totalAmount
})

// 表格列配置
const purchaseDetailHeaders = [
  { title: '采购单号', align: 'start', key: 'purchaseOrderNo', width: '80px' },
  { title: '供应商', align: 'start', key: 'supplierName', width: '180px' },
  // { title: '材料', align: 'center', key: 'goodsName', width: '150px' },
  // { title: '备注', align: 'center', key: 'remark', width: '120px' },
  // { title: '数量', align: 'center', key: 'quantity', width: '100px' },
  // { title: '单位', align: 'center', key: 'unit', width: '100px' },
  // { title: '单价', align: 'center', key: 'price', width: '80px' },
  { title: '采购单总额', align: 'center', key: 'totalAmount', width: '100px' },
  { title: '付款方式', align: 'center', key: 'paymentType', width: '100px' },
  { title: '计划交货', align: 'center', key: 'schDate', width: '115px' },
  // { title: '入库状态', align: 'center', key: 'inboundStatus', width: '100px' },
  { title: '下单人', align: 'center', key: 'createUserName', width: '100px' },
  { title: '入库仓库', align: 'center', key: 'warehouseName', width: '100px' },
]

const detailHead = [
  { title: '材料', align: 'center', key: 'goodsName', width: '150px' },
  { title: '品牌', align: 'center', key: 'brand', width: '100px' },
  { title: '数量', align: 'center', key: 'quantity', width: '100px' },
  { title: '单位', align: 'center', key: 'unit', width: '100px' },
  { title: '单价', align: 'center', key: 'price', width: '80px' },
  { title: '总金额', align: 'center', key: 'totalAmount', width: '100px' },
  { title: '采购备注', align: 'center', key: 'remark', width: '120px' },
  { title: '入库状态', align: 'center', key: 'inboundStatus', width: '100px' }
]

const paymentRecordHeaders = [
  { title: '发起申请', align: 'center', key: 'createTime', width: '140px' },
  { title: '申请金额', align: 'center', key: 'applyAmount', width: '100px' },
  { title: '百分比', align: 'center', key: 'applyPercentage', width: '100px' },
  { title: '签字人', align: 'center', key: 'signatoryName', width: '100px' },
  { title: '回单', align: 'center', key: 'receiptStatus', width: '100px' },
  { title: '操作', align: 'center', key: 'actions', width: '100px' },
]

// 上传回单
const uploadInvoice = (record: PaymentApplicationItem) => {
  showUploadInvoiceDialog.value = true
  currentUploadInvoiceRecord.value = record
}

const handleUploadInvoice = async(fileInfo: any, index: number) => {
  if(fileInfo.length === 0){
    showUploadInvoiceDialog.value = false
    return
  }
  showCommonLoading.value = true
  commonLoadingText.value = '回单上传中...'
  showUploadInvoiceDialog.value = false

  let receiptImages = []
  fileInfo.forEach((item: any) => {
    receiptImages.push(item.url)
  })
  try {
    const res = await purchaseApi.purchasePaymentUploadReceipt({
      id: currentUploadInvoiceRecord.value?.id,
      // receiptImages: fileInfo.map((item: any) => item.url).join(',')
      // receiptImages: JSON.stringify(receiptImages)
      receiptImages: receiptImages
    })
    if(res?.code === 0){
      showSuccess('上传回单成功')
      fetchPurchaseDetail()
    }else{
      showError(res.message)
    }
  } catch (error) {
    showError(error.message || error.msg)
  } finally {
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}

// 获取采购详情数据
const fetchPurchaseDetail = async () => {
  const id = route.params.id || route.query.id
  if (!id) {
    showError('缺少采购单ID')
    return
  }

  try {
    loading.value = true
    const response = await purchaseApi.getPurchaseDetail(Number(id))
    
    if (response.code === 0 && response.data) {
      // 设置采购详情数据
      purchaseDetail.value = response.data.order
      if(response.data.order.goodsName){
        document.title = response.data.order.goodsName
      }else{
        document.title = '采购记录'
      }
      // 设置付款记录数据
      paymentRecords.value = response.data.paymentApplicationList || []
      paymentRecords.value.forEach((item: any) => {
        if(item.receiptImages && typeof item.receiptImages === 'string'){
          item.receiptImages = JSON.parse(item.receiptImages)
        }
        if(item.signatoryName && typeof item.signatoryName === 'string'){
          item.signatoryName = JSON.parse(item.signatoryName)
        }
      })
      // 采购明细
      purchaseDetailList.value = response.data.itemList || []

      if(userType.value === 'payment'){
        paymentRecords.value = paymentRecords.value.filter((item: any) => item.signatoryName && item.signatoryName.length > 0)
      }
      console.log('采购详情:', purchaseDetail.value)
      console.log('付款记录:', paymentRecords.value)
      console.log('采购明细:', purchaseDetailList.value)
    } else {
      showError(response.msg || '获取采购详情失败')
    }
  } catch (error: any) {
    console.error('获取采购详情失败:', error)
    showError(error.message || '获取采购详情失败')
  } finally {
    loading.value = false
  }
}

const getPaymentMethod = (paymentType: string) => {
  let paymentMethod = {
    value: paymentType,
    label: Number(paymentType) === 0 ? '预付' : Number(paymentType) === 1 ? '现付' : '月结'
  }
  return paymentMethod
}

// 获取二维码URL
const getQRCodeUrl = (id: number) => {
  // 根据env配置的环境
  if(import.meta.env.VITE_API_BASE_URL){
    return `${import.meta.env.VITE_API_BASE_URL}/jf/purchase/qrcode?id=${id}`;
  }
}

// 添加格式化数字的函数
const formatNumber = (num: number) => {
  if(num){
    return num.toLocaleString('en-US')
  } else{
    return '0'
  }
}

const formatNYDate = (timestamp: number) => {
  if (!timestamp) return '/'
  const date = new Date(timestamp)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\//g, '/')
}

// 打开付款申请弹窗
const openPaymentDialog = () => {
  paymentDialog.value = true
  // 重置表单
  paymentForm.value = {
    applyAmount: '',
    applyPercentage: ''
  }
}

// 关闭付款申请弹窗
const closePaymentDialog = () => {
  paymentDialog.value = false
  paymentForm.value = {
    applyAmount: '',
    applyPercentage: ''
  }
  paymentFormRef.value?.reset()
}

// 根据金额计算百分比
const calculatePercentage = () => {
  // 如果金额为空，百分比也清空
  if (!paymentForm.value.applyAmount) {
    paymentForm.value.applyPercentage = ''
    return
  }
  
  if (!totalAmount.value) return
  
  const total = parseFloat(totalAmount.value as string)
  
  // 限制金额最多两位小数
  let amountStr = paymentForm.value.applyAmount
  const decimalIndex = amountStr.indexOf('.')
  if (decimalIndex !== -1 && amountStr.length - decimalIndex - 1 > 2) {
    amountStr = parseFloat(amountStr).toFixed(2)
    paymentForm.value.applyAmount = amountStr
  }
  
  let amount = parseFloat(paymentForm.value.applyAmount)
  
  // 限制金额不能大于总金额（精确到小数点）
  if (amount > total) {
    amount = total
    paymentForm.value.applyAmount = total.toFixed(2)
  }
  
  if (total > 0 && amount >= 0) {
    let percentage = Math.round(amount / total * 100)
    
    // 限制百分比最大为100
    if (percentage > 100) {
      percentage = 100
    }
    
    paymentForm.value.applyPercentage = percentage.toString()
  }
}

// 根据百分比计算金额
const calculateAmount = () => {
  // 如果百分比为空，金额也清空
  if (!paymentForm.value.applyPercentage) {
    paymentForm.value.applyAmount = ''
    return
  }
  
  if (!totalAmount.value) return
  
  let percentage = parseInt(paymentForm.value.applyPercentage)
  
  // 确保是整数，不允许小数
  if (isNaN(percentage)) {
    percentage = 0
  }
  
  // 限制百分比在 0-100 之间
  if (percentage < 0) {
    percentage = 0
  } else if (percentage > 100) {
    percentage = 100
  }
  
  // 更新百分比为整数
  paymentForm.value.applyPercentage = percentage.toString()
  
  const total = parseFloat(totalAmount.value as string)
  
  if (percentage > 0 && percentage <= 100) {
    const amount = (total * percentage / 100).toFixed(2)
    paymentForm.value.applyAmount = amount
  } else if (percentage === 0) {
    paymentForm.value.applyAmount = '0'
  }
}

// 提交付款申请
const submitPaymentApplication = async () => {
  if (!paymentForm.value.applyAmount || parseFloat(paymentForm.value.applyAmount) <= 0) {
    showError('请输入有效的申请金额')
    return
  }

  // if (parseFloat(paymentForm.value.applyAmount) > parseFloat(totalAmount.value as string)) {
  //   showError('申请金额不能大于总金额')
  //   return
  // }

  // let applyPercentage = 0
  // paymentRecords.value.forEach((item: any) => {
  //   applyPercentage += item.applyPercentage
  // })
  // if(applyPercentage + parseFloat(paymentForm.value.applyPercentage) > 100){
  //   showError('申请金额不能大于总金额')
  //   return
  // }


  try {
    submitting.value = true
    const response = await purchaseApi.purchasePaymentApply({
      purchaseOrderId: purchaseDetail.value?.id,
      applyAmount: parseFloat(paymentForm.value.applyAmount),
      applyPercentage: paymentForm.value.applyPercentage ? parseFloat(paymentForm.value.applyPercentage) : undefined
    })
    
    if (response.code === 0) {
      showSuccess('付款申请提交成功')
      closePaymentDialog()
      fetchPurchaseDetail()
    } else {
      showError(response.message)
    }
  } catch (error: any) {
    console.error('提交付款申请失败:', error)
    showError(error.message || error.msg)
  } finally {
    submitting.value = false
  }
}

// 打开签字确认弹窗
const signPayment = (record: PaymentApplicationItem) => {
  // 权限检查
  if(!userStore.userInfo.auths.includes('jf_p_p_s')){
    showError('您没有权限签字')
    return
  }

  // if(Number(record.status) === 1){
  //   showError('此付款申请已签字')
  //   return
  // }

  currentSignRecord.value = record
  signConfirmDialog.value = true
}

// 确认签字
const confirmSign = async () => {
  if (!currentSignRecord.value) return

  try {
    loading.value = true
    signConfirmDialog.value = false
    
    const response = await purchaseApi.purchasePaymentSign({
      id: currentSignRecord.value.id,
    })
    
    if (response.code === 0) {
      showSuccess('签字成功')
      await fetchPurchaseDetail()
    } else {
      showError(response.message)
    }
  } catch (error: any) {
    console.error('签字失败:', error)
    showError(error.message || error.msg)
  } finally {
    loading.value = false
    currentSignRecord.value = null
  }
}

// 取消签字
const cancelSign = () => {
  signConfirmDialog.value = false
  currentSignRecord.value = null
}

// 获取图片预览URL
const getImagePreviewUrl = (file: string | File | { url: string; name: string }) => {
  if (!file) return ''
  try {
    if (typeof file === 'string') {
      return file
    }
    if (file instanceof File) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'object' && 'url' in file) {
      return file.url
    }
    return ''
  } catch (error) {
    console.error('创建图片预览URL失败:', error)
    return ''
  }
}

const previewImage = ref<string[]>([])
const showPreview = ref(false)
const currentParentIndex = ref(0)
const selectedIndex = ref(0)
const isDelete = ref(false)
const type = ref<string>('voucher')
// 添加预览相关的方法
const handleImagePreview = (images: [], materialIndex: number, index: number, canDelete: boolean, isType: 'product' | 'wuliao' | 'voucher') => {
  console.log('images', images, materialIndex, index, canDelete, isType)
  // const urls = images.map(image => image.url)
  previewImage.value = images
  showPreview.value = true
  currentParentIndex.value = materialIndex
  selectedIndex.value = index
  isDelete.value = canDelete
  type.value = isType

}

onMounted(() => {
  userType.value = route.params.type as string || 'purchase'
  fetchPurchaseDetail()
})
</script>

<style lang="scss" scoped>
.purchase-detail-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-detail-table :deep(th) {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 12px 8px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.purchase-detail-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
  transition: background-color 0.3s ease;
}

/* 确保表格内容不会溢出 */
.purchase-detail-table :deep(td) > * {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 8px; */
}

.product-table.purchase-detail-table :deep(td) > * {
  max-width: 100%;
  /* overflow: hidden; */
  overflow: visible;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  padding-left: 8px;
  border-left: 3px solid #D2475D;
}

.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background-color: rgba(255, 255, 255, 0.05);
}

:deep(.v-card-text) {
  padding-top: 24px !important;
}

/* 弹窗样式 */
.payment-dialog {
  background-color: #2B2D33 !important;
}

.payment-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.payment-dialog :deep(.v-card-text) {
  padding: 24px;
}

.payment-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.payment-dialog :deep(.v-autocomplete .v-field__input),
.payment-dialog :deep(.v-text-field .v-field__input),
.payment-dialog :deep(.v-autocomplete input),
.payment-dialog :deep(.v-text-field input) {
  color: #fff !important;
}

.payment-dialog :deep(.v-autocomplete .v-field__outline),
.payment-dialog :deep(.v-text-field .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.payment-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.payment-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.payment-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.payment-dialog :deep(.v-autocomplete .v-field__append-inner i),
.payment-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.payment-dialog :deep(.v-text-field__suffix) {
  color: #fff !important;
}

.payment-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.payment-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.payment-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.payment-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.payment-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.payment-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

/* 隐藏数字输入框的箭头 */
.payment-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.payment-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.payment-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

// 动画
.common-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.common-loading-container {
  text-align: center;
  color: #fff;
}

.common-loading-spinner {
  border: 4px solid #2B2D33;
  border-top: 4px solid #D2475D;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.common-loading-text {
  margin-top: 16px;
  font-size: 14px;
}

// 图片预览
.image-preview-item {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0 auto;
}

.image-preview-item .preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview-item:hover .preview-image {
  transform: scale(1.05);
}

.image-preview-item .image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .image-actions {
  opacity: 1;
}

.image-preview-item .image-actions .v-icon {
  color: #fff;
  cursor: pointer;
}

.image-preview-item .image-actions .v-icon:hover {
  color: #ff5252;
}

.payment-type{
  width: 50px;
  padding: 4px 0px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  font-weight: 400;
  color: #E8E8E8;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
}
</style> 